import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Auth/authHelpers';
import { BasicNavigationBar } from './BasicNavigationBar';
import { Footer } from './Footer';
import { NavigationBar } from './NavigationBar';
import { onLogout } from '../../utils/trackingUtils';

export const RootLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const isAuthenticated = !!auth?.currentUser;
  const isLoginPage = location.pathname === '/login';

  const handleLogout = (): void => {
    onLogout();
    auth?.logout();
  };

  const renderNavigation = (): React.ReactNode => {
    if (isAuthenticated) {
      return <NavigationBar onLogout={handleLogout} onNavigate={navigate} />;
    }
    if (!isLoginPage) {
      return <BasicNavigationBar onNavigate={navigate} />;
    }
    return null;
  };

  return (
    <div className="app flex flex-col min-h-screen">
      {renderNavigation()}
      <div className="flex-grow bg-[rgba(252,252,252,1)]">
        <Outlet />
      </div>
      <Footer onNavigate={navigate} />
    </div>
  );
};

export default RootLayout;
